import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import './style.sass'
import { NavLink, useLocation } from 'react-router-dom'
import { useStorage64 } from 'hooks/useStorageBase64'
import { decodeStorage, encodeStorage } from 'functions/storageBase64'
import { BASE_PATH_PORTAL, PORTAL_URL } from 'constants/general'
import Switch from 'components/Forms/Switch'

function ContentMenuPrincipal({ onClose }) {
    const { pathname } = useLocation()
    const [isLoged] = useStorage64('session_token', '')
    const [profileData] = useStorage64('profileData', '')
    const hostName = window.location.origin
    //credito CS
    const creditoCS = decodeStorage("cardending");

    return (
        <div className="moduleMenu">
            <div className="contentMenu">
                <div className="headerModule">
                    {isLoged && profileData
                        ? <div>
                            <p>¡Hola {profileData.nombre}!</p>
                            <span>{profileData.correo}</span>
                        </div>
                        : <div>
                            <a
                                href={hostName+"/login"}
                                className="goToLogin"
                                title="Iniciar Sesión"
                            >
                                Iniciar Sesión
                            </a>
                        </div>
                    }
                </div>

                <div className="contentSubSeccionMenu">
                    {<div className="contSectionMenu">
                        <ul>
                            {pathname !== '/'
                                ? <li><a href="/" exact className="icoInicio" title="Inicio">Inicio</a></li>
                                : <li><a href="/" exact className="icoInicio" onClick={onClose} title="Inicio">Inicio</a></li>
                            }

                            {isLoged
                                ? pathname !== '/micuenta'
                                    ? <li><a exact href={hostName+"/mi-cuenta"} className="icoMiCuenta" title="Mi Cuenta">Mi Cuenta</a></li>
                                    : <li><a exact href={hostName+"/mi-cuenta"} className="icoMiCuenta" onClick={onClose} title="Mi Cuenta">Mi Cuenta</a></li>
                                : null
                            }

                            {pathname !== '/c/ofertas/'
                                ? <li><a href={hostName+"/c/ofertas/"} className="icoOfertas" title="Ofertas">Ofertas</a></li>
                                : <li><a href={hostName+"/c/ofertas/"} className="icoOfertas" onClick={onClose} title="Ofertas">Ofertas</a></li>
                            }

                            {isLoged
                                ? pathname !== '/mi-cuenta/mis-pedidos/'
                                    ? <li><a exact href={hostName+"/mi-cuenta/mis-pedidos/dias=30/pagina=1"} className="icoPedidos" title="Mis pedidos">Mis Pedidos</a></li>
                                    : <li><a exact href={hostName+"/mi-cuenta/mis-pedidos/dias=30/pagina=1"} className="icoPedidos" onClick={onClose} title="Mis pedidos">Mis Pedidos</a></li>
                                : null
                            }
                            {isLoged
                                ? pathname !== '/mi-cuenta/listadeseos/'
                                    ? <li><a exact href={hostName+"/mi-cuenta/listadeseos/"} className="icoWishlist" title="Mi Lista de deseos" activeClassName="active">Mi lista de deseos</a></li>
                                    : <li><a exact href={hostName+"/mi-cuenta/listadeseos/"} className="icoWishlist" onClick={onClose} title="Mi Lista de deseos" activeClassName="active">Mi lista de deseos</a></li>
                                : null
                            }
                            {isLoged
                                ? pathname !== '/credito-claroshop'
                                    ? <li><a exact href={creditoCS ? "/credito-claroshop/home" : "/credito-claroshop/beneficios"} className="icoCredito" title="Mi crédito ClaroShop" activeClassName="active">Mi crédito ClaroShop</a></li>
                                    : <li><a exact href={creditoCS ? "/credito-claroshop/home" : "/credito-claroshop/beneficios"} className="icoCredito" onClick={onClose} title="Mi crédito ClaroShop" activeClassName="active">Mi crédito ClaroShop</a></li>
                                : <li><a href={"/credito-claroshop/beneficios"} className="icoCredito" title="Mi crédito ClaroShop">Mi crédito ClaroShop</a></li>
                            }

                            {isLoged
                                ? pathname !== '/mi-cuenta/direcciones-envio/'
                                    ? <li><a href={hostName+"/mi-cuenta/direcciones-envio/"} className="icoDireccion" title="Mis direcciones">Mis direcciones</a></li>
                                    : <li><a href={hostName+"/mi-cuenta/direcciones-envio/"} className="icoDireccion" onClick={onClose} title="Mis direcciones">Mis direcciones</a></li>
                                : null
                            }
                        </ul>
                    </div>
                    }

                    <div className="contSectionMenu">
                        <ul>
                            {pathname !== '/categoria'
                                ? <li><a href={hostName+"/categoria"} className="icoCategoria" title="Categorías">Categorías</a></li>
                                : <li><a href={hostName+"/categoria"} className="icoCategoria" onClick={onClose} title="Categorías">Categorías</a></li>
                            }
                            <li><a href="https://blog.claroshop.com/" className="icoBlog" >Blog Claroshop</a></li>
                            {pathname !== '/tiendas'
                                ? <li><a href={hostName+"/tiendas"} className="icoTienda" title="Tiendas oficiales">Tiendas oficiales</a></li>
                                : <li><a href={hostName+"/tiendas"} className="icoTienda" onClick={onClose} title="Tiendas oficiales">Tiendas oficiales</a></li>
                            }
                            {pathname !== '/tiendas'
                                ? <li><a href={PORTAL_URL + "/l/vender-en-internet"} rel="noopener noreferrer" className="icoVendeEn" title="Vende en Claroshop.com">Vende en Claroshop.com</a></li>
                                : <li><a href={PORTAL_URL + "/l/vender-en-internet"} rel="noopener noreferrer" className="icoVendeEn" title="Vende en Claroshop.com ">Vende en Claroshop.com</a></li>
                            }
                        </ul>
                    </div>

                    <div className="contSectionMenu">
                        <ul>
                            <li><a href={hostName+"/contacto"} className="icoWhatshapp" title="¿Necesitas ayuda?">¿Necesitas ayuda?</a></li>
                            <li><a href={hostName+"/servicio-cliente"} className="icoServicio" title="Servicio al cliente">Servicio al cliente</a></li>
                            {isLoged
                                ? pathname !== '/ajustes'
                                    ? <li><a href={hostName+"/ajustes"} className="icoAjustes" title="Ajustes">Ajustes</a></li>
                                    : <li><a href={hostName+"/ajustes"} className="icoAjustes" onClick={onClose} title="Ajustes">Ajustes</a></li>

                                : null
                            }
                        </ul>
                    </div>
                </div>

            </div>
            <div className="backgroundMenu" onClick={onClose}></div>
        </div>
    )
}

export default function MenuPrincipal({ onClose }) {
    return ReactDOM.createPortal(
        <ContentMenuPrincipal onClose={onClose} />,
        document.getElementById('modal-root')
    )
}